import styled from '@emotion/styled';
import { alpha, Button } from '@mui/material';
import { shouldForwardProps } from '@dh/utils';
import { ButtonLabel } from '@dh/styles';

const TextButtonWrapper = styled(Button, shouldForwardProps)<{ themeColor?: string }>`
    position: relative;
    padding-left: ${({ theme }) => theme.spacing(1.5)};
    padding-right: ${({ theme }) => theme.spacing(1.5)};
    height: 48px;
    color: ${({ theme, themeColor }) =>
        themeColor ? theme.colors.white : theme.colors.lightSurfaceTint};

    border: 2px solid transparent;
    border-radius: 8px;
    box-shadow:
        0 0 0 2px transparent,
        0 0 0 4px transparent;
    overflow: visible; /* Wichtig, um Ränder sichtbar zu machen */

    > svg {
        height: 18px;
        width: 18px;
    }

    &:hover {
        background-color: ${({ theme, themeColor }) =>
            themeColor ? alpha(themeColor, 0.8) : alpha(theme.colors.primary, 0.08)};
    }

    &:focus {
        border: 2px solid ${({ theme }) => theme.colors.white};
        border-radius: 8px;
        box-shadow:
            0 0 0 2px ${({ theme, themeColor }) => themeColor ?? theme.colors.primary},
            0 0 0 4px
                ${({ theme, themeColor }) =>
                    themeColor ? alpha(themeColor, 0.4) : alpha(theme.colors.primary, 0.4)};
    }
`;

const TextButtonLabel = styled(ButtonLabel, shouldForwardProps)<{
    hasIcon?: boolean;
    isDisabled?: boolean;
    labelColor?: string;
    withUnderline?: boolean;
}>`
    margin-left: ${({ hasIcon, theme }) => (hasIcon ? theme.spacing(1) : 0)};
    color: ${({ theme, isDisabled, labelColor }) =>
        isDisabled
            ? theme.colors.disabledText
            : labelColor ?? theme.colors.onPrimaryDark};
    text-decoration: ${({ withUnderline }) => (withUnderline ? 'underline' : 'none')};
`;

export { TextButtonWrapper, TextButtonLabel };
